import { DEFAULT_NEXT_TRAINING_BUTTON_LABEL } from './programConfig'

export const readCmsTextField = (field, fieldRef) => {
  if (typeof field === 'string' && field.length > 0) return field
  if (Array.isArray(fieldRef) && fieldRef.length > 0) {
    return fieldRef[0]?.content || null
  }
  return null
}

export const hasCmsNextStepFields = markComplete => {
  const {
    nextStepHeader,
    nextStepHeaderRef,
    nextStepButtonLabel,
    nextStepButtonLabelRef,
    nextStepRoute,
    nextStepRouteRef,
  } = markComplete || {}

  const header = readCmsTextField(nextStepHeader, nextStepHeaderRef)
  const button = readCmsTextField(nextStepButtonLabel, nextStepButtonLabelRef)
  const route = readCmsTextField(nextStepRoute, nextStepRouteRef)
  return !!(header || button || route)
}

/**
 * Extracts ordered training article summaries from a curriculum-service
 * subsectionLanding `/trainings` response (snake_case or camelCase).
 */
export const getTrainingLandingArticles = landingPage => {
  const nestedPage = landingPage?.page || landingPage
  const articles = nestedPage?.content || []
  if (!Array.isArray(articles)) return []

  return articles
    .map(article => {
      const courseNodeId =
        article?.courseNodeConnector?.courseNodeEntryPoint ||
        article?.course_node_connector?.course_node_entry_point ||
        null
      const title = article?.displayTitle || article?.display_title || ''
      const slug = article?.pageData?.route || article?.page_data?.route || null
      if (!courseNodeId || !slug) return null
      return { courseNodeId, slug, title }
    })
    .filter(Boolean)
}

/**
 * When curriculum-service omits markComplete next-step fields, derive the Next
 * Training panel from the ordered training landing articles.
 */
export const enrichMarkCompleteWithNextStep = ({
  markComplete,
  trainingArticles,
  courseNodeId,
  pathname,
}) => {
  if (!markComplete || hasCmsNextStepFields(markComplete)) {
    return markComplete
  }
  if (!courseNodeId || !pathname || !Array.isArray(trainingArticles)) {
    return markComplete
  }

  const currentIndex = trainingArticles.findIndex(
    article => article.courseNodeId === courseNodeId,
  )
  if (currentIndex < 0 || currentIndex >= trainingArticles.length - 1) {
    return markComplete
  }

  const nextArticle = trainingArticles[currentIndex + 1]
  const trainingsBasePath = pathname.replace(/\/[^/]+$/, '')
  if (!trainingsBasePath || !nextArticle?.slug) {
    return markComplete
  }

  const partNumber = currentIndex + 2
  return {
    ...markComplete,
    nextStepButtonLabel:
      markComplete.nextStepButtonLabel || DEFAULT_NEXT_TRAINING_BUTTON_LABEL,
    nextStepHeader:
      markComplete.nextStepHeader ||
      `Next Training—Part ${partNumber}: ${nextArticle.title}`,
    nextStepRoute: `${trainingsBasePath}/${nextArticle.slug}`,
  }
}
